// @flow

import { connect } from 'react-redux';

import App from './App';

const mapStateToProps = () => ({});

const AppContainer = connect(mapStateToProps, null)(App);

export default AppContainer;



// WEBPACK FOOTER //
// ./src/AppContainer.js